import React, { useState } from "react";
import { toastError } from "../../utils";
import DateInput from "../DateInput";

const SearchFilter = ({ onSearch }) => {
  const [searchBy, setSearchBy] = useState("name");
  const [searchValue, setSearchValue] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [selectedType, setSelectedType] = useState("");

  const handleSearch = (e) => {
    e.preventDefault();
    const params = {};

    if (searchBy === "name" && searchValue) {
      params.name = searchValue.trim();
    }

    if (searchBy === "type" && selectedType) {
      params.referenceType = selectedType;
    }

    if (searchBy === "date") {
  if (!dateFrom || !dateTo) {
    toastError("Please select both start and end dates");
    return;
  }

  if (new Date(dateTo) < new Date(dateFrom)) {
    toastError("To date cannot be before From date");
    return;
  }

  params.from = dateFrom;
  params.to = dateTo;
}

    onSearch(params);
  };

  const handleClear = () => {
    setSearchValue("");
    setSelectedType("");
    setDateFrom("");
    setDateTo("");
    setSearchBy("name");
    onSearch({});
  };

  return (
    <form
      onSubmit={handleSearch}
      className="d-flex flex-wrap align-items-center gap-2"
    >
      <select
        value={searchBy}
        onChange={(e) => {
          setSearchBy(e.target.value);
          setSearchValue("");
          setSelectedType("");
          setDateFrom("");
          setDateTo("");
        }}
        className="border p-1 rounded text-muted "
      >
        <option value="name">Party Name</option>
        <option value="type">Type</option>
        <option value="date">Date</option>
      </select>

      {searchBy === "name" && (
        <input
          type="text"
          className="border p-1 rounded"
          placeholder="Enter Party Name"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
        />
      )}

      {searchBy === "type" && (
        <select
          value={selectedType}
          onChange={(e) => setSelectedType(e.target.value)}
          className="border p-1 rounded text-muted"
        >
          <option value="">Select Type</option>
          <option value="sale">Sale</option>
          <option value="purchase">Purchase</option>
          <option value="saleReturn">Sale Return</option>
          <option value="purchaseReturn">Purchase Return</option>
          <option value="payment-in">Payment-In</option>
          <option value="payment-out">Payment-Out</option>
        </select>
      )}

      {searchBy === "date" && (
        <div className="d-flex align-items-center gap-2">
          <DateInput value={dateFrom} onChange={setDateFrom} />

          <span>to</span>

          <DateInput value={dateTo} onChange={setDateTo} />
        </div>
      )}

      <button type="submit" className="btn btn-primary btn-sm">
        Search
      </button>

      {(searchValue || selectedType || (dateFrom && dateTo)) && (
        <button
          type="button"
          className="btn border btn-sm"
          onClick={handleClear}
        >
          Clear
        </button>
      )}
    </form>
  );
};

export default React.memo(SearchFilter);
